import { ReactLenis } from 'lenis/react'
import { useReducedMotion } from 'framer-motion'
import type { ReactNode } from 'react'

export default function SmoothScroll({ children }: { children: ReactNode }) {
  const reduce = useReducedMotion()
  if (reduce) return <>{children}</>

  return (
    <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
      {children}
    </ReactLenis>
  )
}
